import { EndAction } from "V2.0/HomePages/PipelinesV2/PipelineBuilderV2/Models/End";

import DefaultEndExecution from "./Default";

export default EndExecution;

const EndActionExecutionRegistry = {
  [EndAction.NONE]: DefaultEndExecution,
  [EndAction.ARCHIVE_CONVERSATION]: DefaultEndExecution,
  [EndAction.WEBHOOK_NOTIFICATION]: DefaultEndExecution,
};

function EndExecution(props) {
  const { node } = props;

  const EndActionExecution =
    EndActionExecutionRegistry[node.data.endAction ?? "none"];

  return <EndActionExecution {...props} />;
}
